import { STEP_IDS } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";

import styles from "./Steps.module.css";

const STEP_NUMBERS = ["01", "02", "03"] as const;

export function Steps() {
  const { copy } = useLocale();

  return (
    <Section id="how-it-works" dark title={copy.steps.title}>
      <ol className={styles.list}>
        {STEP_IDS.map((id, index) => (
          <li key={id} className={styles.item}>
            <span className={styles.number}>{STEP_NUMBERS[index]}</span>
            <p className={styles.text}>{copy.steps.items[id]}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}
